module.exports = __webpack_public_path__ + "img/IMG_0577_8_9_L_Wood.623182f2.jpg";